import { ExtractionDetails } from "./ExtractionDetails";
import { ExtractionStatus } from "./ExtractionStatus";
import { OrderStatus } from "./OrderStatus";

export enum ExtractionState {
  IDLE = "idle",
  PROCESSING = "processing",
  CANCELLED = "cancelled",
  COMPLETED = "completed",
  PENDING = "pending",
  FAILED = "failed",
  PENDING_REVIEW = "pending_review",
  INVALID = "invalid",
}

export const resolveExtractionState = ({
  orderStatus,
  hasValidResponses,
  hasPendingReviewResponses,
  hasInvalidResponses,
  extractionDetails,
}: {
  orderStatus: OrderStatus;
  hasValidResponses: boolean;
  hasPendingReviewResponses: boolean;
  hasInvalidResponses: boolean;
  extractionDetails: ExtractionDetails | null;
}): ExtractionState => {
  if (orderStatus === OrderStatus.CANCELLED) return ExtractionState.CANCELLED;
  if (orderStatus === OrderStatus.PROCESSING) return ExtractionState.PROCESSING;
  if (hasValidResponses) return ExtractionState.COMPLETED;
  if (hasPendingReviewResponses) return ExtractionState.PENDING_REVIEW;
  if (extractionDetails?.status === ExtractionStatus.PENDING) return ExtractionState.PENDING;
  if (extractionDetails?.status === ExtractionStatus.FAILED) return ExtractionState.FAILED;
  if (hasInvalidResponses) return ExtractionState.INVALID;
  return ExtractionState.IDLE;
};
